import { Box, Button, Stack, TextField } from '@mui/material'
import React, { useState } from 'react'
import ViewAgendaOutlinedIcon from '@mui/icons-material/ViewAgendaOutlined';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import EmployeeAccessTrainingGrid from './EmployeeAccessTrainingGrid';
import EmployeeAccessTrainingList from './EmployeeAccessTrainingList';
import IconButton from '@mui/material/IconButton';
import WindowOutlinedIcon from '@mui/icons-material/WindowOutlined';

export default function EmployeeAccessTraining() {
  const [age, setAge] = React.useState('');

  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const [view, setView] = useState(true);
  const Viewed = () => {

    setView(view => !view);

  }
  return (
    <>
      <Box >
        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"

          className="mt-2"
          sx={{ padding: "10px", background: "#fff", marginBottom: "10px" }}>
          <TextField
            placeholder='Search'

            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
              fontFamily: "Arial, FontAwesome"
            }}
            variant="outlined"
            size="small"

          />
          <Stack direction="row" spacing={2} sx={{ float: "right" }}>

            <FormControl fullWidth>

              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={age}
                label="Age"
                onChange={handleChange}
                size="small"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                  minWidth: "200px"
                }}
              >
                <MenuItem value={10}>Ten</MenuItem>
                <MenuItem value={20}>Twenty</MenuItem>
                <MenuItem value={30}>Thirty</MenuItem>
              </Select>
            </FormControl>

            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={Viewed}

              >
                {view ? <ViewAgendaOutlinedIcon /> : <WindowOutlinedIcon />}
              </IconButton>
            </Box>
          </Stack>


        </Box>
        {view && <EmployeeAccessTrainingGrid />}
        {!view && <EmployeeAccessTrainingList />}
      </Box>


    </>
  )
}
